import useSWR from "swr";
import { useContext, useEffect } from "react";
import { Context } from "../../context";
import { fetcher } from "../../utils/fetcher";

const useIndex = (token: string, methods: any) => {
  const { data: ostaliOperateri } = useSWR(
    `${process.env.REACT_APP_API_URL}/operateri/ostali-operateri`,
    (url: string) =>
      fetcher(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
  );

  const { data: drzave } = useSWR(
    `${process.env.REACT_APP_API_URL}/sifrarnici/drzave`,
    fetcher
  );

  const { data: elektronickeAdrese } = useSWR(
    `${process.env.REACT_APP_API_URL}/sifrarnici/elektronicke-adrese`,
    fetcher
  );

  useEffect(() => {
    if (!ostaliOperateri || !drzave || !elektronickeAdrese) return;

    methods.reset((formValues: any) => ({
      ...formValues,
      ostaliOperateri: [...ostaliOperateri.ostaliOperateri],
      drzave,
      elektronickeAdrese: elektronickeAdrese
        ? elektronickeAdrese.filter((adresa: any) => adresa.id !== 1)
        : [],
      loading: false,
    }));
  }, [ostaliOperateri, drzave, elektronickeAdrese]);

  return {
    ostaliOperateri: ostaliOperateri
      ? [...ostaliOperateri.ostaliOperateri]
      : [],
    drzave,
    elektronickeAdrese: elektronickeAdrese
      ? elektronickeAdrese.filter((adresa: any) => adresa.id !== 1)
      : [],
  };
};

export default useIndex;
